<?php
\Core\View::$template = function () {
    $html = '
    <div class="nav_wrap">
      <nav class="navbar navbar-expand-lg fixed-top nav-transparent">
      <div class="container">
        <a class="navbar-brand" href="#" style="height: 90px;">
          <img src="' . IMAGE_ASSET_PREFIX . 'app/Default/Assets/images/logg.png" height="80">
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"><i class="fa fa-bars"></i></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarResponsive">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item active">
              <a class="nav-link" href="#">
                Invite
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Looking for Staff?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link go-register-employee" href="/register/employee">Looking for Work?</a>
            </li>
            <!--<li class="nav-item">
              <a class="nav-link go-register-hiring" href="/register/hiring">Hiring?</a>
            </li>
            <li class="nav-item">
              <a class="nav-link nav-signup go-jobslist" href="/jobslist">Jobs</a>
            </li>-->
            <li class="nav-item">
              <a class="nav-link nav-signup go-login-page" href="/login" >Login</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </div> ';


    $html = $html . '
    <section class="general">
      <div class="container common_question_wrap">
        <h1>Meet the Team</h1>
      </div>
    </section>';

    $html = $html . '

    <section class="footer-bottom">
      <div class="container">
        <div class="row clearfix">
          <div class="col-md-3 col-12 col-xs-12 col-lg-3 copyright_footer">
            © 2023 Video Interviews
          </div>
          <div class="col-md-9 col-12 col-xs-12 col-lg-9">
            <ul class="footer-links">
              <li>
                <a class="go-about-us" href="/about-us">About</a>
              </li>
              <!--<li>
                <a class="go-jobslist" href="/jobslist">Jobs</a>
              </li>-->
              <li>
                <a class="go-careers-with-us" href="/careers-with-us">Careers</a>
              </li>
              <li>
                <a class="go-privacy-policy" href="/privacy">Privacy</a>
              </li>
              <li>
                <a class="go-terms-conditions" href="/terms-and-conditions">Terms</a>
              </li>
              <li>
                <a class="go-contact" href="/contact-us">Contact</a>
              </li>
              <li>
                <a class="go-affiliates" href="/affiliates">Affiliates</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>';

    return $html;
};




// WEBPACK FOOTER //
// app/LandingPage/View/TeamPage.php